<template>
    <div
        class="c-preview"
        id="c-preview"
        :style="{
            backgroundColor: panelDesign.backgroundColor,
            borderColor: panelDesign.borderColor,
            borderWidth: `${panelDesign.borderSize}px`,
            borderRadius: `${panelDesign.borderRadius}px`,
            height: `${panelDesign.widgetHeight}px`,
        }"
    >
        <div
            class="c-preview__title"
            :style="{
                color: panelDesign.textColor,
            }"
        >
            {{ title }}
        </div>
        <div class="c-preview__content position-relative" id="boxesID" style="overflow: hidden">
            <vue-scrolling-ul :style="'height: ' + `${panelDesign.widgetHeight - 143}px`" start infinity :speed="20" :delay="500">
                <DonateItem
                    v-for="donate in donates"
                    :key="donate.id"
                    :data="donate"
                    :showSlamIndication="
                        donate.is_slam
                    "
                    :showDedication="true"
                    :panelDesign="panelDesign"
                />
            </vue-scrolling-ul>
        </div>
        <button
            v-if="data.show_donate_button"
            @click="donate"
            class="btn mt-3"
            :style="{
                backgroundColor:
                    buttonDesign.color,
                color: buttonDesign.textColor,
                borderColor:
                    buttonDesign.borderColor,
                borderWidth: `${buttonDesign.borderSize}px`,
                borderRadius: `${buttonDesign.borderRadius}px`,
            }"
        >
            {{ buttonLabel }}
        </button>
    </div>
</template>

<script>
// import $ from 'jquery';
import DonateItem from "@/components/widgets/components/DonateItem.vue";

export default {
    name: 'PublicWidgetSupporter',
    components: {DonateItem},
    props: {
        data: Object,
    },
    data() {
        return {
            name: '',
            campaign: '',
            campaignsOptions: [],
            title: 'Our Supporters',
            minimumAmount: '',
            showDedication: true,
            showSlamIndication: true,
            showDonateButton: true,
            htmlCode: '',
            buttonLabel: 'Donate',
            tabs: [
                { value: 1, label: 'Content' },
                { value: 2, label: 'Panel' },
                { value: 3, label: 'Button' },
            ],
            activeTab: 1,
            panelDesign: {
                backgroundColor: '#fff',
                textColor: '#212830',
                amountColor: '#2797FF',
                bulletColor: '#2797FF',
                slamColor: '#F9ED32',
                borderColor: '#DEDFE3',
                widgetHeight: 480,
                widgetHeightMin: 0,
                widgetHeightMax: 520,
                widgetHeightStep: 10,
                borderSize: 0,
                borderSizeMin: 0,
                borderSizeMax: 100,
                borderSizeStep: 1,
                borderRadius: 0,
                borderRadiusMin: 0,
                borderRadiusMax: 100,
                borderRadiusStep: 1,
            },
            buttonDesign: {
                textColor: '#fff',
                color: '#2797FF',
                borderColor: '#DEDFE3',
                borderSize: 0,
                borderSizeMin: 0,
                borderSizeMax: 100,
                borderSizeStep: 1,
                borderRadius: 0,
                borderRadiusMin: 0,
                borderRadiusMax: 100,
                borderRadiusStep: 1,
            },
            donates: [],
            boxScrollInterval: null,
        };
    },
    watch: {

    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.name = this.data.name;
            this.title = this.data.title;
            this.minimumAmount = this.data.min_amount;
            this.showDedication = this.data.show_dedication;
            this.showSlamIndication = this.data.show_slam_indication;
            this.showDonateButton = this.data.show_donate_button;
            this.buttonLabel = this.data.button_text;
            this.panelDesign.backgroundColor = this.data.background_color;
            this.panelDesign.textColor = this.data.text_color;
            this.panelDesign.amountColor = this.data.amount_color;
            this.panelDesign.bulletColor = this.data.bullet_color;
            this.panelDesign.slamColor = this.data.slam_color;
            this.panelDesign.widgetHeight = this.data.widget_height;
            this.panelDesign.borderColor = this.data.border_color;
            this.panelDesign.borderSize = this.data.border_size;
            this.panelDesign.borderRadius = this.data.border_radius;
            this.buttonDesign.color = this.data.button_color;
            this.buttonDesign.textColor = this.data.button_text_color;
            this.buttonDesign.borderColor = this.data.button_border_color;
            this.buttonDesign.borderSize = this.data.button_border_size;
            this.buttonDesign.borderRadius = this.data.button_border_radius;

            if (this.data.donors.length) {
                this.data.donors.forEach((donor, index) => {
                    this.donates.push({
                        id: index,
                        username: donor.name,
                        donate: donor.amount,
                        desc: donor.dedication,
                        is_slam: donor.is_slam,
                    });
                });
            }
        },
        donate() {
            // post message to parent window
            window.parent.postMessage({
                action: 'donate',
                widget: this.data,
            }, '*');
        },
    },
};
</script>

<style lang="scss" scoped>
.c-preview {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #ddd;
    width: 300px;
    height: 480px;
    aspect-ratio: 3/4;
    margin-bottom: 30px;
    background: #fff;
    display: flex;
    flex-direction: column;

    &__title {
        font-size: 22px;
        margin-bottom: 12px;
    }
    &__content {
        flex: 1;
        overflow: auto;
    }
}
.scroll-area {
    position: relative;
    margin: auto;
    height: auto;
    max-height: calc(100vh - 120px);
    overflow: auto;
}
</style>
<style type="text/css">
.scroll-area .ps__rail-y { display: none !important; }
</style>
